import { _ } from "../../../core/polyglot/polyglot.js";
import { formatFullWithTwoDecimals } from "../../../core/helpers/currency-formatting-util.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import ledgerEntryTransactionRenderer from "../ledgerEntryTransactionRenderer/ledgerEntryTransactionRenderer.js";
import TableWidget from "../../../core/widgets/list/TableWidget/TableWidget.js";

/**
 * `LedgerEntryTableWidget` displays a table representing the transactions for a ledgerentry.
 *
 * @param {TransactionList} spec.transactionList - A TransactionList containing the
 *    transaction for one ledgerEntry.
 * @param {string} spec.dimensionIdentifier - The current dimension used for linking to account statements.
 */
export default class LedgerEntryTableWidget extends Widget {
	constructor({ transactionList, dimensionIdentifier }) {
		super(...arguments);
		this._dimensionIdentifier = dimensionIdentifier;
		this._transactionList = transactionList;
		this._tableWidget = null;

		this._tableHeaders = [
			_("Text"),
			_("Date"),
			_("Account name"),
			_("Account"),
			{
				name: _("Debit"),
				class: "text-right",
			},
			{
				name: _("Credit"),
				class: "text-right",
			},
		];

		this._tableWidget = new TableWidget({
			rowItems: this._transactionList.getTransactions(),
			rowItemCellsRenderer: (item) =>
				this._transactionCellsRenderer(item),
			footerCssClass: "closing total ledger",
			tableHeaders: this._tableHeaders,
			footerCells: (html) => this._renderFooterCellson(html),
		});
	}

	renderContentOn(html) {
		html.render(this._tableWidget);
	}

	_transactionCellsRenderer(transaction) {
		return ledgerEntryTransactionRenderer({
			transaction,
			dimensionIdentifier: this._dimensionIdentifier,
			numberRenderer: this._numberRenderer,
		});
	}

	_renderFooterCellson(html) {
		html.td({ klass: "bold total-text", colspan: "4" }, _("Total"));

		html.td(
			{ klass: "bold text-right", nowrap: "nowrap" },
			this._numberRenderer(this._transactionList.getSumDebit()),
		);

		html.td(
			{ klass: "bold text-right", nowrap: "nowrap" },
			this._numberRenderer(this._transactionList.getReversedSumCredit()),
		);
	}

	// 0 should not be rendered in this document
	_numberRenderer(number) {
		if (number) {
			return formatFullWithTwoDecimals(number);
		}
		return "";
	}
}
